const redirects = [
    { from: "/blogs/emergency-communications", to: "/a/blog/category/emergency-communications" },
    { from: "/blogs/emergency-power", to: "/a/blog/category/generators-and-emergency-power" },
    { from: "/blogs/food-water-storage", to: "/a/blog/category/food-and-water-storage" },
    { from: "/blogs/fuel-treatment", to: "/a/blog/category/fuel-storage" },
    { from: "/blogs/long-term-foods-reviews", to: "/a/blog/category/other-long-term-food-reviews" },
    { from: "/blogs/media-coverage", to: "/a/blog/category/media-coverage" },
    { from: "/blogs/mountain-house-reviews", to: "/a/blog/category/mountain-house-food-reviews" },
    { from: "/blogs/mre-recipes", to: "/a/blog/category/mres-ready-to-eat-reviews" },
    { from: "/blogs/mre-reviews", to: "/a/blog/category/mres-ready-to-eat-reviews" },
    { from: "/blogs/news", to: "/a/blog/category/whats-happening-theepicenter" },
    { from: "/blogs/news-updates", to: "/a/blog/category/news-updates" },
    { from: "/blogs/peak-refuel-reviews", to: "/a/blog/category/peak-refuel-food-reviews" },
    { from: "/blogs/preparedness-planning", to: "/a/blog/category/preparedness-planning-and-survival-tips" },
    { from: "/blogs/preparedness-tips", to: "/a/blog/category/emergency-preparedness-tips" },
    { from: "/blogs/update", to: "/a/blog/" },
    { from: "/blogs/epicenterjanet", to: "/a/blog/category/other-product-tips-recommendations" },
    { from: "/blogs/videos", to: "/a/blog/category/epicenter-video-blog" },
    { from: "/blogs/other-product-demos-reviews", to: "/a/blog/category/other-product-demos-and-reviews" },
    { from: "/blogs/thermoelectric-generator-reviews", to: "/a/blog/category/other-product-demos-and-reviews" },
    { from: "/blogs/stove-demos-reviews", to: "/a/blog/category/outdoor-stove-demos-and-reviews" },
    { from: "/blogs/freeze-dry-at-home", to: "/a/blog/post/learn-more-about-home-and-business-freeze-dryers" },
    { from: "/blogs/mountain-house-reviews/mountain-house-30-year-shelf-life", to: "/a/blog/post/30-year-shelf-life-for-mountain-house-freeze-dried-food" },
    { from: "/blogs/mountain-house-reviews/review-mountain-house-chili-mac", to: "/a/blog/post/review-mountain-house-chili-mac-dented-can" },
    { from: "/blogs/thermoelectric-generator-review", to: "/a/blog/category/generators-and-emergency-power" },
    { from: "/blogs/augason-farms-reviews", to: "/a/blog/post/augason-farms" },
    { from: "/blogs", to: "/a/blog/" },
];


function handleRedirect() {
    const currentPath = window.location.pathname;

    for (let i = 0; i < redirects.length; i++) {
        if (currentPath === redirects[i].from) {
            window.location.replace(redirects[i].to);
            break;
        }
    }
}

document.addEventListener('DOMContentLoaded', handleRedirect);